import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { XCircle, Home } from 'lucide-react'

export default function AnamneseCanceladaPage() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-rose-100 p-4">
      <div className="max-w-2xl mx-auto py-8">
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <XCircle className="h-16 w-16 text-red-500" />
            </div>
            <CardTitle className="text-2xl text-red-700">
              Link Cancelado
            </CardTitle>
            <CardDescription>
              Este link de acesso foi cancelado pelo administrador.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6 text-center">
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-800">
                O acesso a este formulário foi desativado pelo residencial.
                Se você acredita que isso foi um engano, entre em contato diretamente
                com o responsável.
              </p>
            </div>

            <div className="space-y-3">
              <Button
                onClick={() => window.location.href = 'https://idmovi.com'}
                className="w-full sm:w-auto"
              >
                <Home className="mr-2 h-4 w-4" />
                Ir para Página Inicial
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
